import { ref } from 'vue'

export function useLastPurchasedPrices() {
  const loading = ref(false)
  const lastPurchasedPrices = ref([])

  const fetchLastPurchasedPrices = async (customerId) => {
    if (!customerId) {
      lastPurchasedPrices.value = []
      return Promise.resolve()
    }

    loading.value = true
    try {
      const response = await fetch(`/customers/${customerId}/last_purchased_prices`)
      const data = await response.json()
      lastPurchasedPrices.value = data.products || []
    } catch (error) {
      console.error('Failed to fetch last purchased prices:', error)
      lastPurchasedPrices.value = []
    } finally {
      loading.value = false
    }
  }

  const getLastPurchasedPrice = (productId) => {
    const item = lastPurchasedPrices.value.find(p => p.product_id === productId)
    return item?.last_purchased_price || null
  }

  return {
    loading,
    lastPurchasedPrices,
    fetchLastPurchasedPrices,
    getLastPurchasedPrice
  }
}
